class Slider {
    constructor(elm) {
        this.$elm = $(elm);
        this.init();
    }

    init() {
        this.$elm.slick({
            dots: true,
            arrows: true,
            variableWidth: true,
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: false,
            prevArrow: '<span class="slick-prev slick-slider__button slick-slider__button--prev"><i class="fa fa-chevron-left"></i></span>',
            nextArrow: '<span class="slick-next slick-slider__button slick-slider__button--next"><i class="fa fa-chevron-right"></i></span>',
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                    }
                },
                {
                    breakpoint: 640,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    }
                },
            ],
        });
    }
}

export default Slider;
